import React from 'react';
import { Linkedin } from 'lucide-react';

const Team = () => {
  const teamMembers = [
    {
      name: 'Sara Nomaan',
      role: 'Co-Founder TIFL | Assistant Professor | Parenting Expert',
      image: '/Sara.jfif',
      description: 'With over 14 years of experience in teaching and research, I am dedicated to advancing the fields of Human Development and Family Studies. My work centers around understanding the complexities of human growth, adolescent development, family dynamics, and cross-cultural psychology.',
      linkedin: 'https://www.linkedin.com/in/sara-nomaan-45872033?utm_source=share_via&utm_content=profile&utm_medium=member_android'
    },
    {
      name: 'Abeer Rizwan',
      role: 'Co-Founder TIFL | Coordinator @ Lincoln Corners Pakistan',
      image: '/abeer.jfif',
      description: 'Specializing in Human Development with expertise in Public Relations, Brand Design, Copywriting, Editing, Blogging, and User Experience Writing. Dedicated to fostering growth and development through innovative strategies.',
      linkedin: 'https://www.linkedin.com/in/abeer-rizwan-6b965a248?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app'
    }
  ];

  return (
    <section className="py-20 bg-gray-50" id="team">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-blue-50 rounded-full px-4 py-2 mb-4">
            <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider">Our Team</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0C1D40] mb-6">
            Meet the Founders
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Dedicated professionals committed to child development and family well-being.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto">
          {teamMembers.map((member, index) => (
            <div key={index} className="group bg-white rounded-2xl border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
              <div className="p-8 flex flex-col items-center text-center h-full">
                {/* Image */}
                <div className="w-48 h-48 mb-6 rounded-full overflow-hidden border-4 border-white shadow-lg relative">
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                
                {/* Content */}
                <h3 className="text-2xl font-bold text-[#0C1D40] mb-2">{member.name}</h3>
                <p className="text-blue-600 font-medium mb-4 text-sm uppercase tracking-wide">{member.role}</p>
                <p className="text-gray-600 mb-8 leading-relaxed flex-grow">{member.description}</p>
                
                {/* Social Links */}
                <a 
                  href={member.linkedin}
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-[#0077b5] text-white rounded-full hover:bg-[#005e93] transition-colors"
                >
                  <Linkedin className="w-5 h-5" />
                  <span>Connect on LinkedIn</span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
